<ng-container *ngIf="loading">
	<div class="loading-logo">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<mat-tab-group *ngIf="!loading" [selectedIndex]="0">
	<mat-tab label="Inventory Charts">
		<div class="header-padding">
			<div class="header-container">
				<div class="report-info">
					<h2 class="report-title">Inventory Charts</h2>
					<p class="report-subtitle">
						<span class="subtitle-span">Inventories</span> - Visualize Inventory charts
					</p>
				</div>

				<div *ngIf="siteId" class="export-btn">
					<mat-form-field appearance="outline">
						<mat-label>Select Stockpile</mat-label>

						<input type="text" matInput [matAutocomplete]="stockpileOptions" [formControl]="stockpileControl"/>
						<mat-autocomplete #stockpileOptions="matAutocomplete" [displayWith]="displayStockpileNameFn">
							<mat-option *ngFor="let stockpile of filteredStockpiles | async" [value]="stockpile">{{stockpile.name}}</mat-option>
						</mat-autocomplete>
					</mat-form-field>
				</div>
			</div>
		</div>

		<app-dashboard-chart-group [chartOptions]="chartOptions" [Highcharts]="Highcharts"
			(chartInstance)="onChartInstance($event.chart, $event.index)">
		</app-dashboard-chart-group>
	</mat-tab>

	<mat-tab label="Inventory Data Table View">
		<div class="header-padding">
			<div class="header-container">
				<div class="report-info">
					<h2 class="report-title">Inventory Data Table View</h2>
					<p class="report-subtitle">
						<span class="subtitle-span">Inventories</span> - Visualize Inventory table
					</p>
				</div>
			</div>
		</div>
		<div class="content-container">
			<div class="table-content">
				<table class="data" mat-table [dataSource]="inventoryData">
					<ng-container matColumnDef="site">
						<th mat-header-cell *matHeaderCellDef> Site </th>
						<td mat-cell *matCellDef="let item">{{item.site?.name}}</td>
					</ng-container>
					<ng-container matColumnDef="stockpile">
						<th mat-header-cell *matHeaderCellDef> Stockpile </th>
						<td mat-cell *matCellDef="let item">{{item.stockpile?.name}}</td>
					</ng-container>
					<ng-container matColumnDef="createdAt">
						<th mat-header-cell *matHeaderCellDef> Date </th>
						<td mat-cell *matCellDef="let item">{{item.stockpile?.createdAt | date:'mediumDate'}}</td>
					</ng-container>
					<ng-container matColumnDef="material">
						<th mat-header-cell *matHeaderCellDef> Material </th>
						<td mat-cell *matCellDef="let item">{{item.stockpile?.materialType?.name}}</td>
					</ng-container>

					<ng-container matColumnDef="density">
						<th mat-header-cell *matHeaderCellDef> {{'Density' | UnitDisplayPipe:userUnitMeasurement:'density'}} </th>
						<td mat-cell *matCellDef="let item">
							{{item.stockpile?.materialType?.density | UnitConversionPipe:userUnitMeasurement:'density' | number:'1.0-2'}}
						</td>
					</ng-container>

					<ng-container matColumnDef="price">
						<th mat-header-cell *matHeaderCellDef> {{'Price' | UnitDisplayPipe:userUnitMeasurement:'largeWeight'}} </th>
						<td mat-cell *matCellDef="let item">
							{{item.stockpile?.materialPrice?.price | UnitConversionPipe:userUnitMeasurement:'largeWeight' | currency:item.stockpile?.materialPrice?.currency:'symbol'}}
						</td>
					</ng-container>

					<ng-container matColumnDef="cutVolume">
						<th mat-header-cell *matHeaderCellDef> {{'Cut Volume' | UnitDisplayPipe:userUnitMeasurement:'volume'}} </th>
						<td mat-cell *matCellDef="let item">
							{{item.stockpile?.volume | UnitConversionPipe:userUnitMeasurement:'volume' | number:'1.0-2'}}
						</td>
					</ng-container>

					<ng-container matColumnDef="cutWeight">
						<th mat-header-cell *matHeaderCellDef> {{'Cut Weight' | UnitDisplayPipe:userUnitMeasurement:'largeWeight'}} </th>
						<td mat-cell *matCellDef="let item">
							{{item.weight | UnitConversionPipe:userUnitMeasurement:'largeWeight' | number:'1.0-2'}}
						</td>
					</ng-container>

					<ng-container matColumnDef="totalPrice">
						<th mat-header-cell *matHeaderCellDef> Total Price </th>
						<td mat-cell *matCellDef="let item">{{item.price | currency:item.stockpile?.materialPrice?.currency:'symbol' }}</td>
					</ng-container>

					<ng-container matColumnDef="notes">
						<th mat-header-cell *matHeaderCellDef> Notes </th>
						<td mat-cell *matCellDef="let item">{{item.stockpile?.notes}}</td>
					</ng-container>

					<ng-container matColumnDef="burnRate">
						<th mat-header-cell *matHeaderCellDef> Burn Rate (tn/day) </th>
						<td mat-cell *matCellDef="let item">
						{{item.burnRate ? (item.burnRate | number:'1.0-2') : '—'}}
						</td>
					</ng-container>

					<ng-container matColumnDef="forecastDate">
						<th mat-header-cell *matHeaderCellDef> Forecasted Depletion </th>
						<td mat-cell *matCellDef="let item">
						{{item.forecastDate ? (item.forecastDate | date:'mediumDate') : '—'}}
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
				</table>
			</div>
		</div>
	</mat-tab>
</mat-tab-group>